import React, { useEffect } from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { isCapacitor } from "./lib/platform";

function App() {
  // In Capacitor: listen for deep link (OAuth callback from TikTok)
  useEffect(() => {
    if (!isCapacitor()) return;

    let cleanup;
    (async () => {
      const { App: CapApp } = await import('@capacitor/app');
      const { Browser } = await import('@capacitor/browser');

      cleanup = await CapApp.addListener('appUrlOpen', async (event) => {
        try {
          const url = new URL(event.url);
          if (url.pathname === '/auth/callback') {
            await Browser.close();
            window.history.pushState({}, '', `/auth/callback${url.search}`);
            window.dispatchEvent(new PopStateEvent('popstate'));
          }
        } catch (e) {
          console.error('Deep link error:', e);
        }
      });
    })();

    return () => { if (cleanup) cleanup.remove(); };
  }, []);

  // In Capacitor: configure status bar
  useEffect(() => {
    if (!isCapacitor()) return;

    import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
      StatusBar.setOverlaysWebView({ overlay: false });
      // Dark unified theme (rebrand 2026-04-30): pitch-black bg + light icons.
      // Style.Dark = light text/icons, for use over dark backgrounds.
      StatusBar.setBackgroundColor({ color: '#000000' });
      StatusBar.setStyle({ style: Style.Dark });
    }).catch(() => {});
  }, []);

  return (
    <AuthProvider>
      <TenantProvider>
        <Routes />
      </TenantProvider>
    </AuthProvider>
  );
}

export default App;
